import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Select,
  Spin,
  message,
  Card,
  Checkbox,
  Collapse,
  Icon,
} from "antd";
import { Storage } from "aws-amplify";
import { DatePicker } from "antd";
import { TimePicker } from "antd";
import moment from "moment";
import AppConfigs from "../../Config/AppConfig";
import { getDetails, list, update } from "../../api/Apis";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
import NumberFormat from "react-number-format";

const { Option } = Select;
const format = "hh:mm A";
const { Panel } = Collapse;
const { TextArea } = Input;
class Editorder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
      loading: false,
      cartLoading: false,
      subtotal: 0,
      delivery: 0,
      cartData: [],
      locations: [],
      leadData: [],
      productsData: [],
      startOpen: false,
      endOpen: false,
      startValue: "",
      endValue: "",
      expandIconPosition: "right",
      open: "0",
      sameAddressForAll: false,
      startTime: "",
      endTime: "",
    };
  }

  hasErrors = (fieldsError) =>
    Object.keys(fieldsError).some((field) => fieldsError[field]);

  onChange1(event, index) {
    this.setState({ orderFields: event.target.value });
  }

  onChange = (checkedValues) => {
    console.log("checked = ", checkedValues);
  };
  callback(key) {
    console.log(key);
  }
  componentDidMount = () => {
    const orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let locations = [];
    orgDetails["customerLocations"] &&
      orgDetails["customerLocations"].map((location, index) => {
        let address = location["location"]; // + "," + location["address"] + "," + location["city"] + "," + location["state"] + "," + location["pincode"];
        return locations.push(address);
      });
    getDetails(
      AppConfigs["entityNames"]["leads"],
      this.props.match.params.id
    ).then(async (result) => {
      if (result.success) {
        console.log(result.data);
        result.data["cartItems"].map(async (item) => {
          item["imagePath"] = await Storage.get(item["image"]);
        });

        // this.getProductsData();
        this.setState({
          startTime: moment(
            result.data["deliveryReqTime"].split(" - ")[0],
            "hh:mm A"
          ),
          endTime: moment(
            result.data["deliveryReqTime"].split(" - ")[1],
            "hh:mm A"
          ),
          deliveryDate: moment(result.data["deliveryReqDate"]),
          leadData: result.data,
          locations: locations,
          loading: false,
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoadingStatus: false,
        });
      }
    });
  };

  // getProductsData = () => {
  //   let query = {
  //     customerId: this.state.orgDetails["id"],
  //     isActive: true,
  //   };
  //   list(AppConfigs["entityNames"]["products"], query).then((result) => {
  //     if (result.success) {
  //       // let selectedProduct = result.data.filter((product) => product.id === productId);
  //       this.setState({
  //         productsData: result?.data?.products?.sort((a, b) =>
  //           a["productName"] > b["productName"] ? 1 : -1
  //         ),
  //       });
  //     } else {
  //       console.log(result.errors);
  //       this.setState({
  //         pageLoading: false,
  //       });
  //     }
  //   });
  // };

  changeMeasurementType = async (measurementType, itemId, quantity) => {
    if (
      measurementType.toLowerCase() === "truckload" &&
      parseInt(quantity) > 1
    ) {
      message.error("Only 1 truckload can be ordered at a time.");
      return;
    } else {
      this.setState({
        loading: true,
      });
      this.calculateAmount(measurementType, quantity, itemId);
    }
  };

  changeTruckType = async (deliveryTruck, itemId) => {
    this.setState({
      loading: true,
    });
    let cartItem = this.state.leadData["cartItems"].filter(
      (item) => item.productId === itemId
    );
    cartItem[0]["deliveryTruck"] = deliveryTruck;
    let cartItems = this.state.leadData["cartItems"].filter(
      (item) => item.productId !== itemId
    );
    let leadsData = this.state.leadData;
    cartItems.push(cartItem[0]);
    leadsData["cartItems"] = cartItems;
    this.setState({
      leadData: leadsData,
      loading: false,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values["deliveryStartTime"] > values["deliveryEndTime"]) {
          message.error("Please select valid time");
          return;
        }

        this.setState({
          loading: true,
        });
        let selectedCustomerLocation =
          this.state.orgDetails.customerLocations.filter(
            (location) => location.location === values["location"]
          );
        let leadsData = {};
        let cartItems = this.state.leadData["cartItems"]; //.filter((item) => item.productId !== itemId);
        if (cartItems[0]["totalAmt"] === 0) {
          message.error(
            "This product is currently not available by the " +
              cartItems[0]["measurementType"] +
              ""
          );
          this.setState({
            loading: false,
          });
          return;
        }
        cartItems[0]["deliveryReqDate"] = moment(values["deliveryDate"]).format(
          "MM/DD/YYYY"
        );
        cartItems[0]["deliveryReqTime"] =
          moment(values["deliveryStartTime"]).format("hh:mm A") +
          " - " +
          moment(values["deliveryEndTime"]).format("hh:mm A");
        cartItems[0]["poNumber"] = values["poNumber"];
        cartItems[0]["locationName"] = values["location"];
        cartItems[0]["address"] = selectedCustomerLocation[0]["address"];
        cartItems[0]["notes"] = values["notes"];

        leadsData["deliveryReqDate"] = moment(values["deliveryDate"]).format(
          "MM/DD/YYYY"
        );
        leadsData["deliveryReqTime"] =
          moment(values["deliveryStartTime"]).format("hh:mm A") +
          " - " +
          moment(values["deliveryEndTime"]).format("hh:mm A");
        leadsData["poNumber"] = values["poNumber"];
        // leadsData["locationName"] = values["locationName"];
        leadsData["address"] = selectedCustomerLocation[0]["address"];
        leadsData["notes"] = values["notes"];
        leadsData["cartItems"] = cartItems;
        leadsData["totalAmt"] = cartItems[0]["totalAmt"];
        let data = {
          entityData: leadsData,
        };
        update(
          AppConfigs["entityNames"]["leads"],
          this.props.match.params.id,
          data
        ).then((result) => {
          if (result.success) {
            message.success("Order updated successfully");
            window.location = "/app/orders";
          } else {
            console.log(result.errors);
          }
        });
      }
    });
  };

  quantityIncrement = (measurementType, quantity, itemId) => {
    if (
      measurementType.toLowerCase() === "truckload" &&
      parseInt(quantity) + 1 > 1
    ) {
      message.error("Only 1 truckload can be ordered at a time.");
      return;
    } else {
      this.setState({
        loading: true,
      });
      this.calculateAmount(measurementType, quantity + 1, itemId);
    }
  };
  quantityDecrement = (measurementType, quantity, itemId) => {
    this.setState({
      loading: true,
    });
    this.calculateAmount(measurementType, quantity - 1, itemId);
  };

  calculateAmount = (measurementType, quantity, itemId) => {
    let cartItem = this.state.leadData["cartItems"].filter(
      (item) => item.productId === itemId
    );
    // let products = this.state.productsData.filter(
    //   (product) => product.id === itemId
    // );
    // let sizeInfo = products[0].sizes.filter(
    //   (size) => size.size === cartItem[0]["size"]
    // );
    // let amount = sizeInfo[0][measurementType.toLowerCase()]
    //   ? sizeInfo[0][measurementType.toLowerCase()]
    //   : 0;
    cartItem[0]["quantity"] = quantity;
    cartItem[0]["measurementType"] = measurementType;
    cartItem[0]["totalAmt"] = parseInt(quantity) * cartItem[0].amount;
    let leadsData = this.state.leadData;
    let cartItems = this.state.leadData["cartItems"].filter(
      (item) => item.productId !== itemId
    );
    cartItems.push(cartItem[0]);
    leadsData["cartItems"] = cartItems;
    leadsData["totalAmt"] = cartItem[0]["totalAmt"];
    this.setState({
      leadData: leadsData,
      loading: false,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    let cartData = this.state.leadData["cartItems"]
      ? this.state.leadData["cartItems"]
      : [];
    let subtotal = 0;
    let loading = true;
    cartData.map(async (item, index) => {
      subtotal += parseFloat(item["totalAmt"]);
      if (index === cartData.length - 1) {
        loading = false;
      }
    });
    return (
      <div>
        <Spin spinning={this.state.loading}>
          <Spin spinning={loading}>
            <Row>
              <Form onSubmit={this.handleSubmit}>
                <Col
                  lg={17}
                  md={17}
                  sm={24}
                  xs={24}
                  style={{ padding: "50px" }}
                >
                  <h2 className="quoteheading">
                    {/* To finish ordering process, please, add next <br /> details for each of the items. */}
                    {"Order: #" + this.state.leadData["orderId"] + " - Update"}
                  </h2>
                  {/* <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: '2%', marginLeft: '15px' }}>
                                        <Checkbox value="details" className="custom_checkbox" onChange={this.selectAddress}>The details are the same for all Items</Checkbox>
                                    </Col> */}
                  <Row gutter={8} style={{ marginTop: "8%" }}>
                    <Col lg={1} md={1} ms={24} xs={24} />
                    <Col lg={1} md={1} ms={24} xs={24}>
                      <p style={{ textAlign: "center" }}>#</p>
                    </Col>
                    <Col lg={7} md={7} sm={24} xs={24}>
                      <p style={{ textAlign: "center" }}>Product</p>
                    </Col>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <p style={{ marginLeft: "40px" }}>Quantity</p>
                    </Col>
                    <Col lg={5} md={5} sm={24} xs={24}>
                      <p>Type of Delivery Truck</p>
                    </Col>
                    <Col lg={2} md={2} sm={24} xs={24}>
                      <p>Price Per Ton</p>
                    </Col>
                  </Row>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <div>
                      {cartData.map((item, index) => {
                        return (
                          <Collapse
                            key={item["id"]}
                            defaultActiveKey={["1"]}
                            expandIconPosition={this.state.expandIconPosition}
                            expandIcon={({ isActive }) => (
                              <Icon
                                type="caret-down"
                                rotate={isActive ? 180 : 0}
                              />
                            )}
                            onChange={this.callback}
                            className="custom_collapse"
                            style={{ marginTop: "2%", borderRadius: "10px" }}
                          >
                            <Panel
                              header={
                                <div>
                                  <Row gutter={8}>
                                    <Col
                                      lg={1}
                                      md={1}
                                      sm={24}
                                      xs={24}
                                      style={{ marginTop: "20px" }}
                                    >
                                      <Checkbox.Group
                                        defaultValue={["order"]}
                                        style={{ width: "100%" }}
                                        onChange={this.onChange}
                                      >
                                        <Checkbox
                                          value="order"
                                          className="custom_checkbox"
                                        />
                                      </Checkbox.Group>
                                    </Col>
                                    <div
                                      onClick={(event) =>
                                        event.stopPropagation()
                                      }
                                    >
                                      <Col
                                        lg={1}
                                        md={1}
                                        sm={24}
                                        xs={24}
                                        style={{ marginTop: "20px" }}
                                      >
                                        <p>1</p>
                                      </Col>
                                      <Col lg={7} md={7} sm={24} xs={24}>
                                        <img
                                          style={{
                                            width: "70px",
                                            height: "60px",
                                            borderRadius: "5px",
                                          }}
                                          src={item["imagePath"]}
                                          alt="img"
                                        />
                                        <span style={{ marginLeft: "10px" }}>
                                          <b>
                                            {item["productName"] +
                                              " - " +
                                              item["size"]}
                                          </b>
                                        </span>
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={6}
                                        sm={24}
                                        xs={24}
                                        style={{ marginTop: "20px" }}
                                      >
                                        {/* <span className="count" style={{ textDecoration: 'underline' }}>{item["quantity"]}</span> */}
                                        <div>
                                          {item["quantity"] <= 1 ? (
                                            <Button
                                              disabled
                                              className="quantitybtn"
                                              onClick={() => {
                                                this.quantityDecrement(
                                                  item["measurementType"],
                                                  item["quantity"],
                                                  item["productId"]
                                                );
                                              }}
                                            >
                                              -
                                            </Button>
                                          ) : (
                                            <Button
                                              className="quantitybtn"
                                              onClick={() => {
                                                this.quantityDecrement(
                                                  item["measurementType"],
                                                  item["quantity"],
                                                  item["productId"]
                                                );
                                              }}
                                            >
                                              -
                                            </Button>
                                          )}
                                          <span className="count">
                                            {item["quantity"]}
                                          </span>
                                          <Button
                                            className="quantitybtn"
                                            onClick={() => {
                                              this.quantityIncrement(
                                                item["measurementType"],
                                                item["quantity"],
                                                item["productId"]
                                              );
                                            }}
                                          >
                                            +
                                          </Button>

                                          <Select
                                            className="cartquantitydropdown"
                                            notFoundContent={"Not found?!"}
                                            defaultValue={
                                              item["measurementType"]
                                            }
                                            onChange={(value) => {
                                              this.changeMeasurementType(
                                                value,
                                                item["productId"],
                                                item["quantity"]
                                              );
                                            }}
                                            style={{
                                              width: "110px",
                                              fontSize: "16px",
                                            }}
                                          >
                                            {/* <Option value='ton'>Ton</Option> */}
                                            <Option value="Pallet">
                                              Pallet
                                            </Option>
                                            {/* <Option value='yard'>Yard</Option> */}
                                            {item["quantity"] <= 1 && (
                                              <Option value="Truckload">
                                                Truckload
                                              </Option>
                                            )}
                                          </Select>
                                        </div>
                                      </Col>
                                      <Col
                                        lg={5}
                                        md={5}
                                        sm={24}
                                        xs={24}
                                        style={{ marginTop: "20px" }}
                                      >
                                        <Select
                                          className="cartquantitydropdown"
                                          notFoundContent={"Not found?!"}
                                          defaultValue={item["deliveryTruck"]}
                                          placeholder="Delivery Truck"
                                          mode="multiple"
                                          // onChange={(value) => this.setState({ deliveryTruck: value })}
                                          onChange={(value) => {
                                            this.changeTruckType(
                                              value,
                                              item["productId"]
                                            );
                                          }}
                                          style={{ width: "90%" }}
                                        >
                                          <Option value="Tractor Trailer">
                                            Tractor Trailer
                                          </Option>
                                          <Option value="Dump Truck/Triaxle">
                                            Dump Truck/Triaxle
                                          </Option>
                                          <Option value="Mason Dump">
                                            Mason Dump
                                          </Option>
                                          <Option value="Flatbed with forklift">
                                            Flatbed with forklift
                                          </Option>
                                          <Option value="Flatbed">
                                            Flatbed
                                          </Option>
                                        </Select>
                                      </Col>
                                      <Col
                                        lg={2}
                                        md={2}
                                        sm={24}
                                        xs={24}
                                        style={{ marginTop: "20px" }}
                                      >
                                        <span
                                          className="cartitemtext"
                                          style={{
                                            fontSize: "17px",
                                            float: "right",
                                          }}
                                        >
                                          {"$" + item["totalAmt"]}
                                        </span>
                                      </Col>
                                      {/* <Col lg={2} md={2} sm={24} xs={24} style={{ marginTop: '20px' }}>
                                    <img src={Trash} alt="img" onClick={() => { if (window.confirm('Are you sure you want to delete this item?')) this.deleteCartItem(item["id"]) }} style={{ cursor: "pointer", marginLeft: "50px" }} />
                                  </Col> */}
                                    </div>
                                  </Row>
                                </div>
                              }
                              key="1"
                            >
                              <Row>
                                <Col lg={24} md={24} sm={24} xs={24}>
                                  <Row gutter={10}>
                                    <Col lg={10} md={10} sm={24} xs={24}>
                                      <Form.Item
                                        className="Formitem"
                                        label={
                                          <span className="label">PO #</span>
                                        }
                                        required={false}
                                      >
                                        {getFieldDecorator("poNumber", {
                                          rules: [
                                            {
                                              required: false,
                                              message:
                                                "Please input your po number",
                                            },
                                          ],
                                          initialValue: item["poNumber"],
                                        })(<Input />)}
                                      </Form.Item>
                                    </Col>
                                    <Col lg={14} md={14} sm={24} xs={24}>
                                      <Form.Item
                                        className="Formitem"
                                        label={
                                          <span className="label">
                                            Location
                                          </span>
                                        }
                                      >
                                        {getFieldDecorator("location", {
                                          rules: [
                                            {
                                              required: true,
                                              message:
                                                "Please select your location",
                                            },
                                          ],
                                          initialValue: item["locationName"],
                                        })(
                                          <Select
                                            placeholder={"Selection location"}
                                            // onChange={(e) => this.changeFieldValue(e, index, '_location')}
                                          >
                                            {this.state.locations.map(
                                              (location, index) => (
                                                <Option
                                                  key={"location" + index}
                                                  value={location}
                                                >
                                                  {location}
                                                </Option>
                                              )
                                            )}
                                          </Select>
                                        )}
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row gutter={10}>
                                    <Col lg={6} md={6} sm={24} xs={24}>
                                      <Form.Item
                                        className="Formitem"
                                        label={
                                          <span className="label">
                                            Requested Date
                                          </span>
                                        }
                                      >
                                        {getFieldDecorator("deliveryDate", {
                                          rules: [
                                            {
                                              required: true,
                                              message:
                                                "Please input requested delivery date",
                                            },
                                          ],
                                          initialValue: moment(
                                            item["deliveryReqDate"],
                                            "MM/DD/YYYY"
                                          ),
                                        })(
                                          <DatePicker
                                            format="MM-DD-YYYY"
                                            //   defaultOpenValue={moment(item["deliveryReqDate"], 'MM/DD/YYYY')}
                                            // onChange={(e) => this.changeFieldValue(e, index, '_deliveryDate')}
                                            // onChange={this.datefield}
                                            disabledDate={(current) => {
                                              return (
                                                current &&
                                                current.valueOf() < Date.now()
                                              );
                                            }}
                                          />
                                        )}
                                      </Form.Item>
                                    </Col>
                                    <Col lg={6} md={6} sm={24} xs={24}>
                                      <Form.Item
                                        className="Formitem"
                                        label={
                                          <span className="label">
                                            Preferred Delivery Hours
                                          </span>
                                        }
                                        required={false}
                                      >
                                        <Row gutter={10}>
                                          <Col lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item>
                                              {getFieldDecorator(
                                                "deliveryStartTime",
                                                {
                                                  rules: [
                                                    {
                                                      required: false,
                                                      message:
                                                        "Please input requested delivery start time",
                                                    },
                                                  ],
                                                  //   initialValue: item["deliveryReqTime"].split(" - ")[0]
                                                  initialValue: moment(
                                                    item[
                                                      "deliveryReqTime"
                                                    ].split(" - ")[0],
                                                    "hh:mm A"
                                                  ),
                                                }
                                              )(
                                                <TimePicker
                                                  placeholder="Start Time"
                                                  format={format}
                                                  // open={this.state.startOpen}
                                                  // defaultValue={moment(item["deliveryReqTime"].split(" - ")[0], 'hh:mm A')}
                                                  use12Hours={true}
                                                  // onChange
                                                  // onOpenChange={(startOpen) => this.setState({ startOpen })}
                                                  // onChange={(value) => this.setStartValue(item["id"], value, index, '_deliveryStartTime')}
                                                  onChange={(value) => {
                                                    this.setState({
                                                      startTime: value,
                                                    });
                                                  }}
                                                  minuteStep={15}
                                                  // disabledHours={this.getStartDisabledHours}
                                                  // disabledMinutes={this.getStartDisabledMinutes}
                                                  // addon={() => (
                                                  //   <Button size="small" type="primary" onClick={() => this.setState({ startOpen: false })}>
                                                  //     Ok
                                                  //   </Button>
                                                  // )}
                                                />
                                              )}
                                            </Form.Item>
                                          </Col>
                                          <Col lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item>
                                              {getFieldDecorator(
                                                "deliveryEndTime",
                                                {
                                                  rules: [
                                                    {
                                                      required: false,
                                                      message:
                                                        "Please input requested delivery end time",
                                                    },
                                                  ],
                                                  //   initialValue: item["deliveryReqTime"].split(" - ")[1]
                                                  initialValue: moment(
                                                    item[
                                                      "deliveryReqTime"
                                                    ].split(" - ")[1],
                                                    "hh:mm A"
                                                  ),
                                                }
                                              )(
                                                <TimePicker
                                                  placeholder="End Time"
                                                  format={format}
                                                  use12Hours={true}
                                                  minuteStep={15}
                                                  // onChange={(value)=>{this.setState({endTime:value});alert(value)}}
                                                  // defaultOpenValue={moment(item["deliveryReqTime"].split(" - ")[1], 'hh:mm A')}
                                                  // onOpenChange={() => this.setState({ endOpen: true })}
                                                  // onSelect={(value) => this.setEndValue(value,index,'_deliveryEndTime')}
                                                  // onOpenChange={(value) => this.setEndValue(value, index, '_deliveryEndTime', item["id"])}
                                                  // disabledHours={this.getEndDisabledHours}
                                                  // disabledMinutes={this.getEndDisabledMinutes}
                                                  // addon={() => (
                                                  //   <Button size="small" type="primary" onClick={() => this.setState({ endOpen: false })}>
                                                  //     Ok
                                                  //   </Button>
                                                  // )}
                                                />
                                              )}
                                            </Form.Item>
                                          </Col>
                                        </Row>
                                      </Form.Item>
                                    </Col>
                                    <Col lg={10} md={10} sm={24} xs={24}>
                                      <p
                                        style={{
                                          marginTop: "7%",
                                          marginLeft: "4%",
                                        }}
                                      >
                                        <b>Note:</b> We cannot guarantee the
                                        delivery date will be the date
                                        requested. However the date chosen will
                                        help educate us on the urgency of your
                                        order.
                                      </p>
                                    </Col>

                                    {/* <Col lg={14} md={14} sm={24} xs={24}>
                                  <Form.Item className="Formitem"
                                    label={<span className="label">Deliver By</span>}>
                                    {getFieldDecorator(item["id"]+'_deliverBy', {
                                      rules: [{ required: true, message: 'Please input your Deliver By' }],
                                    })(<Input onChange={(e) => this.changeFieldValue(e.target.value,index,'_deliverBy')}/>)}
                                  </Form.Item>
                                </Col> */}
                                  </Row>
                                  <Col lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                      className="Formitem"
                                      label={
                                        <span className="label">Notes</span>
                                      }
                                    >
                                      {getFieldDecorator("notes", {
                                        rules: [
                                          {
                                            required: false,
                                            message: "Please input your Notes",
                                          },
                                        ],
                                        initialValue: item["notes"],
                                      })(<TextArea size="large" />)}
                                    </Form.Item>
                                  </Col>
                                </Col>
                              </Row>
                            </Panel>
                          </Collapse>
                        );
                      })}
                    </div>
                  </Col>
                </Col>

                <Col lg={7} md={7} sm={24} xs={24}>
                  <div className="site-card-border-less-wrapper">
                    <Card style={{ minHeight: "88vh" }}>
                      <div style={{ marginTop: "10vh" }}>
                        <h3 className="cartheading">Summary</h3>
                        <Row>
                          <Col lg={18} md={18} sm={24} xs={24}>
                            <h3 className="subtotal">Subtotal</h3>
                          </Col>
                          <Col lg={6} md={6} sm={24} xs={24}>
                            <h3 className="subtotal" style={{ float: "right" }}>
                              <NumberFormat
                                value={parseFloat(subtotal).toFixed(2)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                            </h3>
                            {/* <h3 className="subtotal" style={{ float: "right" }}>{"$" + parseFloat(subtotal).toFixed(2)}</h3> */}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={18} md={18} sm={24} xs={24}>
                            <h3 className="subtotal">Delivery</h3>
                          </Col>
                          <Col lg={6} md={6} sm={24} xs={24}>
                            <h3 className="subtotal" style={{ float: "right" }}>
                              <NumberFormat
                                value={parseFloat(this.state.delivery).toFixed(
                                  2
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                            </h3>
                            {/* <h3 className="subtotal" style={{ float: "right" }}>{"$" + parseFloat(this.state.delivery).toFixed(2)}</h3> */}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={18} md={18} sm={24} xs={24}>
                            <h3 className="subtotal" style={{ color: "black" }}>
                              Total
                            </h3>
                          </Col>
                          <Col lg={6} md={6} sm={24} xs={24}>
                            <h3
                              className="subtotal"
                              style={{ color: "black", float: "right" }}
                            >
                              <NumberFormat
                                value={parseFloat(
                                  subtotal + this.state.delivery
                                ).toFixed(2)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                              {/* {"$" + parseFloat(subtotal + this.state.delivery).toFixed(2)} */}
                            </h3>
                          </Col>
                        </Row>
                      </div>
                      <Form.Item
                        style={{ marginBottom: "30px", textAlign: "center" }}
                      >
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="confirmorder"
                        >
                          Complete Order
                        </Button>
                      </Form.Item>
                    </Card>
                  </div>
                  {/* </div> */}
                </Col>
              </Form>
            </Row>
          </Spin>
        </Spin>
      </div>
    );
  }
}

export default Form.create({ name: "Editorder" })(
  withAppContext(withRouter(Editorder))
);
